import React from "react";
import PropTypes from "prop-types";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import usePermissions from "../../../hooks/usePermissions";
import UnauthorizedScreen from "../../auth/screens/UnauthorizedScreen";
import { routes } from "../../../routes/app-routes";

const PrivateStandVirtualRoute = ({
  component: Component,
  requiredPermissions = [],
  ...rest
}) => {
  const { hasAnyPermission, roles } = usePermissions();
  const authUserData = useSelector((state) => state.auth.authUserData);
  const { prestador, isEmailUser } = authUserData || {};

  const renderComponent = (props) => {
    // Check if email user has no roles configured
    const hasEmailSymbol = (typeof prestador?.codigo === 'string' && prestador?.codigo?.includes("@")) || prestador?.email?.includes("@") || isEmailUser;
    
    if (hasEmailSymbol && roles.length === 0) {
      return <Redirect to={routes.unauthorized} />;
    }

    if (requiredPermissions.length === 0) {
      return <Component {...props} />;
    }

    const hasAccess = hasAnyPermission(requiredPermissions);

    if (!hasAccess) {
      return (
        <UnauthorizedScreen
          requiredPermissions={requiredPermissions}
          message={`No tienes los permisos necesarios para acceder a esta página. Se requieren los siguientes permisos: ${requiredPermissions.join(", ")}`}
        />
      );
    }

    return <Component {...props} />;
  };

  return <Route {...rest} render={renderComponent} />;
};

PrivateStandVirtualRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  requiredPermissions: PropTypes.arrayOf(PropTypes.string),
};

export default PrivateStandVirtualRoute;
